// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoriesDisplay_container__1pRzb","overlay":"CategoriesDisplay_overlay__2zxi9","text":"CategoriesDisplay_text__3QtwC"};